import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { throttle } from 'lodash/function'

export default class WindowBreakpoints extends Component {
    static propTypes = {
        render: PropTypes.func,
        breakpoints: PropTypes.object,
        breakpointSteps: PropTypes.object,
    }

    constructor (props) {
        super()

        this.state = {
            up: this.up,
            down: this.down,
            breakpoint: false,
            breakpointWidth: false,
            ...this.calculateBreakpoint(props),
        }

        this.handleResize = throttle(this.handleResize, 50)
    }

    /**
     * Util function to check if window width is higher than provided breakpoint.
     * Accessible for rendered component via state passed in render (this.props.render(this.state)).
     */
    up = (breakpoint) => {
        return this.state.breakpointWidth > this.props.breakpointSteps[breakpoint]
    }

    down = (breakpoint) => {
        return this.state.breakpointWidth <= this.props.breakpointSteps[breakpoint]
    }

    handleResize = () => {
        const properties = this.calculateBreakpoint(this.props)
        if (this.state.breakpoint !== properties.breakpoint) {
            this.setState({ ...properties })
        }
    }

    calculateBreakpoint = (props) => {
        const { breakpointSteps } = props
        const width = window.innerWidth
        const key = Object.keys(breakpointSteps).reverse().find((key) => {
            return breakpointSteps[key] < width
        })

        return {
            breakpoint: key,
            breakpointWidth: breakpointSteps[key],
        }
    }

    componentDidMount () {
        const properties = this.calculateBreakpoint(this.props)
        this.setState({ ...properties })
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.handleResize)
    }

    render () {
        return (
            <>
                {this.props.render(this.state)}
            </>
        )
    }
}
